import { useState } from 'react';

import { useChannel } from 'ably/react';

type UseAssignmentEndedModalParams = {
  accountId?: string;
  userId?: string;
  cfsId?: string | null;
  cfsNumber?: string;
  queuedCount?: number;
};

export const useAssignmentEndedModal = ({
  accountId,
  userId,
  cfsId,
  cfsNumber,
  queuedCount = 0,
}: UseAssignmentEndedModalParams) => {
  const [showAssignmentEnded, setShowAssignmentEnded] =
    useState<boolean>(false);
  const [assignmentEndedTitle, setAssignmentEndedTitle] =
    useState<string>('CFS Closed');
  const [assignmentEndedMessage, setAssignmentEndedMessage] =
    useState<string>('');

  useChannel(
    `account:${accountId}:cfs:${cfsId}`,
    `closed:cfs:${cfsId}:user:${userId}`,
    (message) => {
      if (queuedCount > 0 || message?.data?.id !== cfsId) return;
      const number = cfsNumber || cfsId || '';
      setAssignmentEndedMessage(
        `Your assignment for ${number} has been ended by the dispatcher.`,
      );
      setAssignmentEndedTitle('Assignment Ended');
      setShowAssignmentEnded(true);
    },
  );

  useChannel(
    `account:${accountId}:cfs:${cfsId}`,
    `closed:cfs:${cfsId}`,
    (message) => {
      if (queuedCount > 0 || message?.data?.id !== cfsId) return;
      const number = cfsNumber || cfsId || '';
      setAssignmentEndedMessage(
        `The CFS you are assigned to ${number}, has been closed by the dispatcher.`,
      );
      setAssignmentEndedTitle('CFS Closed');
      setShowAssignmentEnded(true);
    },
  );

  const dismissAssignmentEnded = () => {
    setShowAssignmentEnded(false);
  };

  return {
    showAssignmentEnded,
    assignmentEndedTitle,
    assignmentEndedMessage,
    dismissAssignmentEnded,
  };
};
